import React from 'react'
import '../App.css';
import Herosection from '../components/Herosection';
import About from '../components/About';
import About2 from '../components/About2';
import Upcomingevent from '../components/Upcomingevent';
import Bookingtomulaqaat from '../components/Bookingtomulaqaat';
import Reviews from '../components/Reviews';
import Experience from '../components/Experience';
import Faq from '../components/Faq';
import Latestevent from '../components/Latestevent';
import Subscribe from '../components/Subscribe';
import { Helmet } from "react-helmet-async"

const Home = () => {
  return (
    <div>

       <Helmet>
      <title>The Event House</title>
      </Helmet>
    
      <Herosection />
      <About />
      <About2 />
      <Upcomingevent /> 
      <Bookingtomulaqaat />
      <Reviews />
      <Experience />
      <Faq />
      <Latestevent />
      <Subscribe />  
    
    </div>
  )
}

export default Home
